import { v4 as uuidv4 } from 'uuid'

class NumericOption {
    constructor({
        optionId,
        isDefault = false,
        numericValue,
    }) {
        this.id = uuidv4()
        this.optionId = optionId
        this.isDefault = isDefault || false
        this.numericValue = numericValue
    }

    toJSON() {
        return {
            optionId: this.optionId,
            isDefault: this.isDefault,
            numericValue: Number(this.numericValue),
        }
    }
}

export default NumericOption
